import { computeCountervalue } from '../../utils/computeCountervalue';
import { useAccountRateTransformApi } from '../api';

export const useAccountRatesCountervalue = () => {
  const result = useAccountRateTransformApi({
    transformFunction: computeCountervalue,
  });
  return result;
};
